/* eslint-disable */
import { getBrowserInfo } from '../base/common';
import throttle from '../utils/throttle';
import {Swiper,Navigation,Pagination,Thumbs} from 'swiper'

(function ($, gridBreakPoints) {

  const breakPointWidth = gridBreakPoints.sm;

  const $button = $('.gallery-box__current-menu');
  const $buttonInner = $('.gallery-box__current-menu-inner');
  const $menu = $('.gallery-box__menu');
  const $menuContainer = $('.gallery-box__menu-container');
  const $menuInner = $('.gallery-box__menu-inner');
  const $menuItem = $('.gallery-box__menu-item');
  const $menuLink = $('.gallery-box__menu-link');
  const $menuLinkCurrent = $('.gallery-box__menu-link--current');
  const thumbnails = document.querySelectorAll('.gallery-box__desktop-slide--thumb');

  $buttonInner.on('click', () => {
    $menuContainer.removeAttr('style');
    $menu.toggleClass('expanded');
  })

  function lazyImageMobile() {
    $('.lazy-picture-mobile').each(function () {
      const $picture = $(this);
      if ($picture.visible(true) && !$picture.hasClass('lazy-picture-mobile--loaded')) {
        const $source = $picture.find('source');
        const $img = $picture.find('img');
        const dataSrc = $img.attr('data-src');
        $source.each(function () {
          const $this = $(this);
          const dataSrcset = $this.attr('data-srcset');
          $this.attr('srcset', dataSrcset);
        });
        $img.attr('src', dataSrc);
        $picture.addClass('lazy-picture-mobile--loaded');
      }
    });
  }

  function galleryMenuInit() {
    $button.removeClass('gallery-box__current-menu--collapsed');
    $buttonInner.removeClass('gallery-box__current-menu-inner--collapsed');
    $menu.removeClass('gallery-box__menu--collapsed');
    $menuContainer.removeClass('gallery-box__menu-container--collapsed').show();
    $menuInner.removeClass('gallery-box__menu-inner--collapsed');
    $menuItem.removeClass('gallery-box__menu-item--collapsed');
    $menuLink.removeClass('gallery-box__menu-link--collapsed');
    $menuLinkCurrent.removeClass('gallery-box__menu-link--collapsed');

    if ($menuInner.innerWidth() + 30 > $menuContainer.innerWidth()) {
      $button.addClass('gallery-box__current-menu--collapsed');
      $buttonInner.addClass('gallery-box__current-menu-inner--collapsed');
      $menu.addClass('gallery-box__menu--collapsed');
      $menuContainer.addClass('gallery-box__menu-container--collapsed').hide();
      $menuInner.addClass('gallery-box__menu-inner--collapsed');
      $menuItem.addClass('gallery-box__menu-item--collapsed');
      $menuLink.addClass('gallery-box__menu-link--collapsed');
      $menuLinkCurrent.addClass('gallery-box__menu-link--collapsed');
    }
  }

  function galleryMobileInit() {
    const $overlay = $('.gallery-box__mobile-overlay');

    if ($('.gallery-box__mobile-container').length === 0) {
      return false;
    }

    if ($overlay.length === 0) {
      return false;
    }

    $('body').addClass('overflow-hidden');
    $overlay.show().toggleClass('gallery-box__mobile-overlay--open').animate({ opacity: 1 }, 200, 'linear');

    const $gallery = new Swiper('.gallery-box__mobile-container', {
      loop: true,
      lazy: {
        loadPrevNext: true,
        preloaderClass: 'gallery-box__preloader',
      },
      spaceBetween: 10,
      hashNavigation: {
        replaceState: true,
        watchState: true,
        loadOnTransitionStart: true,
      },
      on: {
        slideChange() {
          lazyImageMobile();
        },
      },
    });

    $gallery.lazy.load();
  }

  function galleryMobileClose(event) {
    const $overlay = $('.gallery-box__mobile-overlay');
    const container = $('.gallery-box__mobile-slide');
    if (!$overlay.hasClass('gallery-box__mobile-overlay--open')) {
      return false;
    }
    if (!container.is(event.target) && container.has(event.target).length === 0) {
      // forceStopVideos();
      $overlay.removeClass('gallery-box__mobile-overlay--open').animate({ opacity: 0 }, 200, 'linear', () => {
        $('body').removeClass('overflow-hidden');
        $overlay.hide();
      });
    }
  }

  function lazyImageDesktop() {
    $('.lazy-picture-desktop').each(function () {
      const $picture = $(this);
      if ($picture.visible(true) && !$picture.hasClass('lazy-picture-desktop--loaded')) {
        const $source = $picture.find('source');
        const $img = $picture.find('img');
        const dataSrc = $img.attr('data-src');
        $source.each(function () {
          const $this = $(this);
          const dataSrcset = $this.attr('data-srcset');
          $this.attr('srcset', dataSrcset);
        });
        $img.attr('src', dataSrc);
        $picture.addClass('lazy-picture-desktop--loaded');
      }
    });
  }

  $(window).on('load', () => {
    let loadDelay = 0;
      if (getBrowserInfo().name === 'IE') {
        loadDelay = 100;
      }
      setTimeout(() => {
        galleryMenuInit();
      }, loadDelay);
  });

  $(window).on('resize', throttle(galleryMenuInit, 50));

  $(document).on('ready', () => {
    if ($button.length === 0) {
      return false;
    }
    if ($buttonInner.length === 0) {
      return false;
    }
    $button.on('click tap', () => {
      $buttonInner.toggleClass('gallery-box__current-menu-inner--open');
      $menuContainer.slideToggle();
    });
  });

  $(document).on('click tap', '.gallery-box__mobile-item', () => {
    galleryMobileInit();
  });

  $(window).on('load scroll resize click tap', () => {
    if ($(window).width() >= breakPointWidth) {
      lazyImageDesktop();
    }
    if ($(window).width() < breakPointWidth) {
      lazyImageMobile();
    }
  });

  $(document).mouseup((event) => {
    galleryMobileClose(event);
  });

  if ($('.gallery-box__desktop-container--image').length === 0) {
    return false;
  }
  if ($('.gallery-box__desktop-container--thumb').length === 0) {
    return false;
  }

  const galleryThumb = new Swiper('.gallery-box__desktop-container--thumb', {
    spaceBetween: 10,
    slidesPerView: 10,
    preloadImages: false,
    modules: [Navigation, Pagination,Thumbs],
    lazy: {
      loadPrevNext: false,
      preloaderClass: 'gallery-box__preloader',
    },
    loop: false,
    freeMode: true,
    loopedSlides: 11, // looped slides should be the same
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    on: {
      init() {
        $('.gallery-box__desktop').animate({ opacity: 1 }, 300, 'linear');
      },
      slideChange() {
        lazyImageDesktop();
      },
    },
  });

  const galleryImage = new Swiper('.gallery-box__desktop-container--image', {
    spaceBetween: 10,
    preloadImages: false,
    modules: [Navigation, Pagination,Thumbs],
    lazy: {
      loadPrevNext: false,
      preloaderClass: 'gallery-box__preloader',
    },
    loop: false,
    loopedSlides: 5, // looped slides should be the same
    navigation: {
      nextEl: '.gallery-box__navigation--next',
      prevEl: '.gallery-box__navigation--prev',
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    hashNavigation: {
      watchState: true,
      loadOnTransitionStart: true,
    },
    thumbs: {
      swiper: galleryThumb,
      slideThumbActiveClass: 'gallery-box__desktop-slide--active',
    },
    on: {
      slideChange() {
        lazyImageDesktop();
      },
    }
  });

  $(document).one('keyup', (event) => {
    if (event.keyCode === 9) {
      $('.gallery-box__menu-link--current').focus();
    }
  });

  $(document).on('keyup', '.gallery-box__navigation--next', (event) => {
    const currentThumbnail = document.querySelector('.gallery-box__desktop-slide--active');
    thumbnails.forEach((el) => el.setAttribute('tabindex', -1))
    currentThumbnail.setAttribute('tabindex', 0);
  });

  thumbnails.forEach((el) => {
    el.addEventListener('keyup',() => {
      if (el.classList.contains('gallery-box__desktop-slide--active')) {
        thumbnails.forEach((elem) => elem.setAttribute('tabindex', 1))
      }

      if (event.keyCode === 13) {
        lazyImageDesktop();
      }
    })
  });

  $(document).on('click tap', '.gallery-box__desktop-slide--thumb', () => {
    lazyImageDesktop();
  });

  $(document).on('keyup', '.gallery-box__desktop-slide--thumb', (event) => {
    if (event.keyCode === 9) {
      document.location.hash = $(event.target).attr('data-hash');
      lazyImageDesktop();
    }
    if (event.keyCode === 13) {
      let slideIndex = $(event.target).attr('data-hash');
      galleryThumb.slideTo(slideIndex);
      galleryImage.slideTo(slideIndex);
      lazyImageDesktop();
      const dataSlideId = `desktop-${$(event.target).attr('data-hash')}`;
      $(`#${dataSlideId}`).find('.content-video__play').click();
    }
  });
}(jQuery, gridBreakPoints));
